import React from 'react';
import './GoogleMapSection.css';

const GOOGLE_MAPS_EMBED_URL =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.2345!2d78.4775313!3d17.4425243!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9b01b3e64243%3A0xf6ee217b2d263344!2s3rd%20Floor%2C%20Skyline%20Backpackers-Premium%20Co-living%2C%20ICICI%20Bank%2C%20Penderghast%20Road%2C%20Sindhi%20Colony%2C%20Begumpet%2C%20Hyderabad%2C%20Telangana!5e0!3m2!1sen!2sin!4v1692263551234!5m2!1sen!2sin';

const GoogleMapSection = () => (
  <section className="google-map-section">
    <div className="google-map-container">
      <h2 className="map-title">Find Us On Google Maps</h2>
      <p className="map-subtitle">Get directions to Skyline Backpackers</p>
      <div className="map-embed-wrapper">
        <iframe
          src={GOOGLE_MAPS_EMBED_URL}
          width="100%"
          height="350"
          style={{ border: 0, borderRadius: '16px', boxShadow: '0 2px 18px 0 rgba(31,41,55,0.08)' }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Google Map Location"
        ></iframe>
      </div>
    </div>
  </section>
);

export default GoogleMapSection;
